export enum MarketplaceItemStatus {
  Available = 0,
  SoldOut = 1,
  ComingSoon = 2,
  NotEnoughPoints = 3,
  MemberLimitReached = 4,
  AllInBasket = 5,
  All = -1
}

export const ActionLabels = {
  AvailableItem: 'Buy Now',
  AvailableEvent: 'Book Now',
  SoldOut: 'Sold Out',
  ComingSoon: 'Coming Soon',
  NotEnoughPoints: 'Not Enough Points',
  MemberLimitReached: 'Limit Reached',
  AllInBasket: 'Already in Basket',
};

export const TEXT_COLOR = {
  BLACK: 'text-rewards-black',
  RED: 'text-rewards-danger',
  GREEN: 'text-rewards-success',
  NEW: 'text-rewards-new',
};

export const MARKETPLACE_STATE = {
  LIMITED: 'marketplace.limited.stock',
  FEATURED: 'marketplace.featured.stock',
  REMAINING: 'marketplace.panel.remaining.stock',
  NEW: 'marketplace.new.stock',
  SOLD_OUT: 'marketplace.redeem.sold.out',
  NOT_ENOUGH_POINT: 'marketplace.redeem.not.enough.points',
  COMING_SOON: 'marketplace.redeem.coming.soon',
  LIMIT_REACHED: 'marketplace.redeem.member.limit',
  ALL_IN_BASKET: 'marketplace.redeem.all.in.basket',
};
